<template>

  <v-row align="center" justify="center" height="100vh" min-height="100vh" fill-height>
    <v-col align="center" justify="center">
      <WaitForCounselorInstant />
    </v-col>
  </v-row>

</template>

<script>

import WaitForCounselorInstant from "@/components/WaitForCounselorInstant.vue";

export default {
  name: 'InstantMeetingView',
  components: {
      WaitForCounselorInstant
  },
  data: () => ({
  
  }),

}

</script>